import { ofType } from 'redux-observable';
import { debounceTime, switchMap, map, catchError } from 'rxjs/operators';
import { from, of } from 'rxjs';
import { REQUEST_CUSTOMER_NAMES, EPIC_ERROR } from 'Constants/redux';
import service from 'Api/service';
import { receiveCustomerNames } from 'Actions';

const fetchCustomerNamesEpic = (action$) =>
  action$.pipe(
    ofType(REQUEST_CUSTOMER_NAMES),
    debounceTime(500),
    switchMap(({ filter }) => {
      const { numberPer: per, query, page, categories } = filter;
      return from(
        service.get(
          `${
            import.meta.env.VITE_API_DOMAIN
          }/api/customer_location_relationships/names`,
          { per, query, page, categories }
        )
      ).pipe(
        map((response) => receiveCustomerNames(response)),
        catchError((error) => {
          console.error('fetchCustomerNamesEpic error', error);
          return of({ type: EPIC_ERROR });
        })
      );
    })
  );

export default fetchCustomerNamesEpic;
